export default __webpack_public_path__ + "static/Corporate-fa7e67c18ae1507ad5a4398ad05855ae.jpg";